/* Approximate connection location stays within Growganica; ByteStand provides delivery dates. */
(function () {
  'use strict';
  var ENDPOINT = 'https://growganica-delivery-location.alex-5a2.workers.dev/location';
  var CACHE_KEY = 'gg-delivery-geo-v1';
  var CHOICE_KEY = 'gg-delivery-choice-v1';
  var TTL = 30 * 60 * 1000;
  function read(key) { try { return JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (e) { return null; } }
  function write(key, value) { try { sessionStorage.setItem(key, JSON.stringify(value)); } catch (e) {} }
  function nativeZip() { try { return sessionStorage.getItem('zipCode') || ''; } catch (e) { return ''; } }
  function normalize(value, country) {
    var code = String(value || '').trim().toUpperCase();
    if (country === 'US') return /^\d{5}(?:-\d{4})?$/.test(code) ? code.slice(0, 5) : '';
    if (country === 'GB') {
      code = code.replace(/\s/g, '');
      return /^(GIR0AA|[A-Z]{1,2}\d[A-Z\d]?\d[A-Z]{2})$/.test(code) ? code.slice(0, -3) + ' ' + code.slice(-3) : '';
    }
    return '';
  }
  function boot() {
    var chip = document.querySelector('[data-bytestand-chip]');
    if (!chip || chip.dataset.ggLocationBound) return;
    chip.dataset.ggLocationBound = 'true';
    var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
    var country = currency === 'USD' ? 'US' : currency === 'GBP' ? 'GB' : '';
    var note = chip.querySelector('[data-gg-location-note]');
    if (!note) { note = document.createElement('p'); note.className = 'gg-shipchip__location'; note.setAttribute('data-gg-location-note', ''); note.setAttribute('aria-live', 'polite'); chip.insertBefore(note, chip.querySelector('.gg-shipchip__body')); }
    var editing = false;
    var automatic = false;
    var pending = null;
    var controller = null;
    var observer = null;
    var retry = null;
    var expiry = null;
    function setState(state, message) {
      chip.dataset.ggLocationState = state;
      if (note.textContent !== message) note.textContent = message;
    }
    function manualRequired() { setState('unverified', 'Enter your delivery ZIP or postal code for an estimate.'); }
    function stopPending() { pending = null; if (controller) controller.abort(); clearInterval(retry); clearTimeout(expiry); }
    function controls() { return { input: chip.querySelector('#zipCode'), apply: chip.querySelector('#applyButton') }; }
    function expectPostal(postalCode) {
      if (!window.GGDeliveryGuard) return;
      var purchase = window.GGPurchaseState && window.GGPurchaseState.getState();
      window.GGDeliveryGuard.expect(postalCode ? { country: country, postalCode: postalCode, sku: purchase && purchase.variant && purchase.variant.sku } : null);
    }
    function persist(source, postalCode, city) { write(CHOICE_KEY, { source: source, country: country, postalCode: postalCode, city: city || '' }); }
    function showSource(source) {
      setState(source, source === 'geo' ? 'Approximate area from your connection; change ZIP or postal code if needed.' : 'Using the delivery ZIP or postal code you entered.');
    }
    chip.addEventListener('input', function (e) {
      if (automatic || e.target.id !== 'zipCode') return;
      editing = true;
      stopPending();
      expectPostal(null);
      setState('editing', 'Apply your ZIP or postal code to update the delivery estimate.');
    }, true);
    chip.addEventListener('focusin', function (e) {
      if (automatic || e.target.id !== 'zipCode') return;
      editing = true;
      stopPending();
    });
    // Keep a mouse activation on Apply stable while the ZIP input blurs. The
    // host theme scrolls focused controls; that can move Apply between down/up.
    // Keyboard activation retains ordinary focus and click behavior.
    chip.addEventListener('mousedown', function (e) {
      if (e.button === 0 && e.target.closest('#applyButton')) e.preventDefault();
    });
    chip.addEventListener('click', function (e) {
      var button = e.target.closest('#applyButton');
      if (!button) return;
      // The app button is always a button, never a cart submitter.
      button.type = 'button';
      if (automatic) return;
      editing = true;
      stopPending();
      var input = chip.querySelector('#zipCode');
      var code = normalize(input && input.value, country);
      if (code) { expectPostal(code); persist('manual', code); showSource('manual'); }
      else manualRequired();
    }, true);
    function applyPending() {
      if (!pending || editing) return false;
      var fields = controls();
      if (!fields.input || !fields.apply || document.activeElement === fields.input) return false;
      var app = chip.querySelector('#bytestand-app-block');
      if (app && getComputedStyle(app).display === 'none') return false;
      // Native ZIP Apply must remain outside the Shopify product form.
      if (fields.apply.closest('form[action*="/cart"]')) { manualRequired(); stopPending(); return false; }
      fields.apply.type = 'button';
      var choice = pending;
      automatic = true;
      fields.input.value = choice.postalCode;
      fields.input.dispatchEvent(new Event('input', { bubbles: true }));
      fields.input.dispatchEvent(new Event('change', { bubbles: true }));
      if (fields.apply.disabled) { automatic = false; return false; }
      expectPostal(choice.postalCode);
      persist(choice.source, choice.postalCode, choice.city);
      showSource(choice.source);
      pending = null;
      fields.apply.click();
      automatic = false;
      clearInterval(retry); clearTimeout(expiry);
      return true;
    }
    function queue(choice) {
      if (editing) return;
      pending = choice;
      if (applyPending()) return;
      retry = setInterval(applyPending, 250);
      expiry = setTimeout(function () { if (pending) { stopPending(); manualRequired(); } }, 15000);
    }
    observer = new MutationObserver(function () {
      var fields = controls();
      if (fields.apply && fields.apply.type !== 'button') fields.apply.type = 'button';
      applyPending();
    });
    observer.observe(chip, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'style'] });
    var saved = read(CHOICE_KEY);
    var storedCode = normalize(nativeZip(), country);
    var savedCode = saved && saved.country === country ? normalize(saved.postalCode, country) : '';
    // ByteStand writes zipCode only on Apply. A legacy saved ZIP is a manual choice.
    if (storedCode && (!saved || saved.source !== 'geo' || savedCode !== storedCode)) {
      persist('manual', storedCode);
      showSource('manual');
      queue({ source: 'manual', postalCode: storedCode });
      return;
    }
    if (saved && saved.source === 'manual' && savedCode) {
      showSource('manual');
      queue({ source: 'manual', postalCode: savedCode });
      return;
    }
    var dnt = navigator.doNotTrack || window.doNotTrack;
    if (!country || navigator.globalPrivacyControl === true || dnt === '1' || dnt === 'yes') { manualRequired(); return; }
    var cached = read(CACHE_KEY);
    if (cached && Date.now() - cached.at < TTL) {
      var cacheCode = cached.country === country && normalize(cached.postalCode, country);
      if (cacheCode) { queue({ source: 'geo', postalCode: cacheCode, city: cached.city || '' }); return; }
      manualRequired(); return;
    }
    if (ENDPOINT.indexOf('__GG_') === 0) { manualRequired(); return; }
    setState('unverified', 'Finding an approximate area for your delivery estimate…');
    controller = new AbortController();
    var timeout = setTimeout(function () { controller.abort(); }, 3000);
    fetch(ENDPOINT, { method: 'GET', credentials: 'omit', cache: 'no-store', referrerPolicy: 'no-referrer', signal: controller.signal })
      .then(function (response) { if (!response.ok) throw new Error('Location unavailable'); return response.json(); })
      .then(function (location) {
        if (editing) return;
        var locationCountry = String(location.countryCode || '').toUpperCase();
        var postalCode = location.available === true && locationCountry === country && normalize(location.postalCode, country);
        write(CACHE_KEY, { country: locationCountry, postalCode: postalCode || '', city: String(location.city || '').slice(0, 80), at: Date.now() });
        if (!postalCode) { manualRequired(); return; }
        queue({ source: 'geo', postalCode: postalCode, city: location.city || '' });
      })
      .catch(function () { if (!editing) manualRequired(); })
      .finally(function () { clearTimeout(timeout); });
    window.addEventListener('pagehide', function () { stopPending(); if (observer) observer.disconnect(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
